//Scroll
window.addEventListener("scroll", (ev) => {
    const scrollPosition = window.scrollY;
    if (scrollPosition > 0) {
        document.body.classList.add('pdw-scrolled');
    } else {
        document.body.classList.remove('pdw-scrolled');
    }
});

let lastScrollTop = 0;

window.addEventListener("scroll", function() {
    let st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > lastScrollTop){
        // Vers le bas
        document.body.classList.add('scrolltobottom');
        document.body.classList.remove('scrolltotop');
    } else {
        // Vers le haut
        document.body.classList.add('scrolltotop');
        document.body.classList.remove('scrolltobottom');
    }
    lastScrollTop = st <= 0 ? 0 : st; // Pour éviter des valeurs négatives
}, false);